import {useIsFeatureActive} from '@aboutyou/feature-flags';

export const useIsInteractiveTileActive = () => {
  return useIsFeatureActive('desk_interactive_category_tile').isActive;
};
